/* eslint-disable max-len */
import { ImageField } from "react-admin";
import { muiColors } from "themes/colors";
import { Box } from "@mui/material";
import withoutImageCompanyLogo from "assets/withoutImageCompanyLogo.png";

interface GalleryImageProps {
  source: string;
  width?: string;
  height?: string;
  empty?: string | JSX.Element;
  badgeNumber?: number;
  logoSource?: string;
}

const GalleryImage = ({
  source,
  width = "100%",
  height = "180px",
  empty = "Not added",
  badgeNumber,
  logoSource
}: GalleryImageProps) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: width,
        height: height,
        minWidth: "250px",
        backgroundColor: muiColors.bg.default,
        borderRadius: "8px",
        ":has(.RaImageField-image)": {
          ".withoutImage": {
            display: "none"
          }
        },
        "& .galleryImage": {
          minWidth: "250px",
          width: `${width} !important`,
          height: `${height} !important`
        },
        "& .logoImage": {
          position: "absolute",
          top: "16px",
          left: "16px",
          borderRadius: "6px",
          zIndex: 2,
          "& img": {
            border: "solid 2px rgba(253, 253, 253, 0.6)",
            minWidth: "44px",
            width: "44px !important",
            height: "44px !important",
            borderRadius: "4px"
          }
        },
        ".RaImageField-image": {
          objectFit: "cover !important",
          objectPosition: "top !important",
          minWidth: "250px",
          width: `${width} !important`,
          height: `${height} !important`,
          margin: "0px !important",
          borderRadius: "8px"
        }
      }}
    >
      <ImageField source={source} className="galleryImage" />
      {logoSource && (
        <>
          <div
            className="w-[40px] h-[40px] rounded-[6px] absolute top-[18px] left-[18px]"
            style={{
              zIndex: 1,
              backgroundImage: `url(${withoutImageCompanyLogo})`
            }}
          />
          <ImageField source={logoSource} className="logoImage" />
        </>
      )}
      <Box
        className="withoutImage"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "12px",
          color: muiColors.text.disabled
        }}
      >
        {empty}
      </Box>
      {badgeNumber && (
        <div
          className="absolute bottom-[8px] left-[8px] text-[12px] text-mono-primaryTextColor
        font-[500] bg-mono-primaryLightBgColor rounded-[64px] leading-[20px] px-[7px] z-10"
        >
          <span>{badgeNumber}</span>
          {badgeNumber === 1 && <span> - Cover</span>}
        </div>
      )}
    </Box>
  );
};

export default GalleryImage;
